import { useNavigate, useLocation } from "react-router-dom";
import SmartImage from "@/components/SmartImage";
import { cardImage } from "@/lib/img";
import { GitCompareArrows, X, Trash2 } from "lucide-react";
import { useCompare } from "@/context/CompareContext";

export default function CompareBar() {
  const { items, remove, clear } = useCompare();
  const navigate = useNavigate();
  const location = useLocation();
  if (items.length === 0 || location.pathname === "/compare") return null;

  return (
    <div className="fixed bottom-4 inset-x-0 z-50 px-4 pointer-events-none">
      <div className="max-w-3xl mx-auto bg-ink-950 text-white rounded-2xl shadow-2xl p-3 pl-4 flex items-center gap-3 pointer-events-auto fade-up" data-testid="compare-bar">
        <GitCompareArrows className="w-5 h-5 text-brand shrink-0" />
        <div className="flex -space-x-2 shrink-0">
          {items.map((i) => (
            <div key={i.id} className="relative">
              <SmartImage width={160} src={i.image_url} alt="" className="w-10 h-10 rounded-lg object-cover border-2 border-ink-950 bg-white" />
              <button onClick={() => remove(i.id)} className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-brand flex items-center justify-center" aria-label="Remove">
                <X className="w-2.5 h-2.5" />
              </button>
            </div>
          ))}
        </div>
        <span className="text-sm text-neutral-300 hidden sm:block flex-1">{items.length} selected · same type</span>
        <button onClick={clear} data-testid="compare-clear" className="text-neutral-400 hover:text-white p-2" aria-label="Clear"><Trash2 className="w-4 h-4" /></button>
        <button onClick={() => navigate(`/compare?ids=${items.map((i) => i.id).join(",")}`)} disabled={items.length < 2} data-testid="compare-go"
          className="inline-flex items-center gap-2 h-10 px-5 rounded-full bg-brand hover:bg-brand-hover font-semibold text-sm transition-colors disabled:opacity-50 whitespace-nowrap">
          Compare {items.length >= 2 ? `(${items.length})` : ""}
        </button>
      </div>
    </div>
  );
}
